import React from "react";
import { Settings as SettingsIcon } from "lucide-react";
import ComingSoon from "../components/ComingSoon";

const SettingsPage = () => (
  <ComingSoon
    icon={SettingsIcon}
    title="Chức năng đang phát triển"
    description="Trang cài đặt đang được xây dựng. Vui lòng quay lại sau."
  />
);

export default SettingsPage;